import {
  CTA,
  HeroImage,
  ContentCard,
} from '../models/ContentCard';

const BLUR_MOBILE_HEIGHT = 6;
const BLUR_MOBILE_WIDTH = 8;
const BLUR_WEB_HEIGHT = 3;
const BLUR_WEB_WIDTH = 8;

const defaultContentCard = ContentCard();
const imageWidthAndHeightSizes = [
  '320_136',
  '640_271',
  '960_407',
  '1280_542',
  '1600_678',
  '1920_813',
  '2240_949',
  '2560_1084',
  '2880_1220',
];

const formatHeroImageSize = (data, forMobile = false) => imageWidthAndHeightSizes.map(size => {
  // web: img_320_136
  // mobile: img_m_320_136
  const imageUrl = data[`${forMobile ? 'img_m' : 'img'}_${size}`];

  if (!imageUrl) return null;

  const sizes = size.split('_');
  return {
    height: Number(sizes[1]),
    width: Number(sizes[0]),
    url: imageUrl,
    webpUrl: null,
  };
});

const formatNewCTA = (gtm, url) => ({
  gtm: JSON.parse(gtm),
  url,
});

const formatHeroImage = extras => {
  const forMobile = true;
  const { blurImageUrl, mobileBlurImageUrl } = extras;
  const heroImageSizes = formatHeroImageSize(extras).filter(imageSize => !!imageSize);
  const heroMobileImageSizes = formatHeroImageSize(extras, forMobile)
    .filter(imageSize => !!imageSize);

  return {
    alternatives: {
      Mobile: {
        blur: {
          height: BLUR_MOBILE_HEIGHT,
          width: BLUR_MOBILE_WIDTH,
          url: mobileBlurImageUrl,
        },
        sizes: heroMobileImageSizes,
      },
    },
    blur: {
      height: BLUR_WEB_HEIGHT,
      width: BLUR_WEB_WIDTH,
      url: blurImageUrl,
    },
    sizes: heroImageSizes,
  };
};

/**
 * @description
 * expect "extras" property of a card includes following properties:
 * - gtm: json in string, e.g. {"action":"hero","category":"test","label":"test label"}
 * - blurImageUrl,
 * - mobileBlurImageUrl,
 * - img_<width>_<height> responsive image url
 * - ...
 * - img_m_<width>_<height> responsive image url
 * - ...
 *
 * @param {*} card
 */
const formatContentCard = card => {
  try {
    const { url, extras } = card;
    const { gtm } = extras;

    const cta = {
      ...(CTA()),
      ...formatNewCTA(gtm, url),
    };

    const heroImage = {
      ...(HeroImage()),
      ...formatHeroImage(extras),
    };

    return { ...defaultContentCard, cta, hero_image: heroImage };
  } catch (error) {
    return null;
  }
};

const formatContentCards = contentCards => (
  contentCards.map(formatContentCard).filter(card => !!card)
);

export default formatContentCards;
